import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { PropTypes } from 'prop-types';

const UiProgress = ({ value }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress variant='determinate' value={value} />
    </Box>
  );
};
UiProgress.propTypes = {
  value: PropTypes.number,
};
export default UiProgress;
